/**
 * LOGGER OTTIMIZZATO - Sostituisce 300+ console.log
 * Sistema di logging ad alte performance per FantAPP
 */

const LogLevel = {
  ERROR: 0,
  WARN: 1, 
  INFO: 2,
  DEBUG: 3
};

class OptimizedLogger {
  constructor() {
    // Configurazione basata su ambiente
    this.level = window.DEBUG_MODE ? LogLevel.DEBUG : LogLevel.ERROR;
    this.enabled = window.DEBUG_MODE === 'true';
    this.buffer = [];
    this.maxBufferSize = 100;
  }

  /**
   * Log di errore (sempre attivo)
   */
  error(message, ...args) {
    if (this.level >= LogLevel.ERROR) {
      console.error('[FANTAPP ERROR]', message, ...args);
      this.addToBuffer('ERROR', message, args);
    }
  }

  /**
   * Log di warning (solo in debug)
   */
  warn(message, ...args) {
    if (this.enabled && this.level >= LogLevel.WARN) {
      console.warn('[FANTAPP WARN]', message, ...args);
      this.addToBuffer('WARN', message, args);
    }
  }

  /**
   * Log informativo (solo in debug)
   */
  info(message, ...args) {
    if (this.enabled && this.level >= LogLevel.INFO) {
      console.info('[FANTAPP INFO]', message, ...args);
      this.addToBuffer('INFO', message, args);
    }
  }

  /**
   * Log di debug (solo in debug dettagliato)
   */
  debug(message, ...args) {
    if (this.enabled && this.level >= LogLevel.DEBUG) {
      console.debug('[FANTAPP DEBUG]', message, ...args);
      this.addToBuffer('DEBUG', message, args);
    }
  }

  /**
   * Performance measurement
   */
  time(label) {
    if (this.enabled) {
      console.time(`[FANTAPP] ${label}`);
    }
  }

  timeEnd(label) {
    if (this.enabled) {
      console.timeEnd(`[FANTAPP] ${label}`);
    }
  }

  /**
   * Aggiunge al buffer interno
   */
  addToBuffer(level, message, args) {
    this.buffer.push({
      timestamp: Date.now(),
      level,
      message,
      args
    });

    // Mantieni buffer size limitato
    if (this.buffer.length > this.maxBufferSize) {
      this.buffer.shift();
    }
  }

  /**
   * Ottieni logs dal buffer
   */
  getLogs(level = null) {
    if (!level) return this.buffer;
    return this.buffer.filter(log => log.level === level);
  }

  /**
   * Pulisci buffer
   */
  clear() {
    this.buffer.length = 0;
  }

  /**
   * Abilita/Disabilita logging
   */
  setEnabled(enabled) {
    this.enabled = enabled;
  }
}

// Singleton globale
export const logger = new OptimizedLogger();

// Helper per sostituire velocemente i console.log esistenti
export const log = {
  error: (msg, ...args) => logger.error(msg, ...args),
  warn: (msg, ...args) => logger.warn(msg, ...args), 
  info: (msg, ...args) => logger.info(msg, ...args),
  debug: (msg, ...args) => logger.debug(msg, ...args),
  time: (label) => logger.time(label),
  timeEnd: (label) => logger.timeEnd(label)
};
